/* jshint esversion: 8 */
(function(Theme, $, undefined) {
    const t = Theme;
    
    const userSettings = JSON.parse(localStorage.getItem("__UserSettings"));
    if (userSettings != null) {
        document.documentElement.setAttribute('data-theme', userSettings.UserInterfaceTheme.toLocaleLowerCase());
    }

}(window.Theme = window.Theme || {}, jQuery));